import React from 'react';
import { Dropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './MenuComponente.css';
import { useProvider } from '../../context/MenuProvider'; // Importando o hook do contexto

const MenuComponente = () => {
  const { selectedItem, handleSelect, links, btns } = useProvider(); // Acessa o contexto com os links atualizados

  return (
    <div>
      <Dropdown onSelect={handleSelect}>
        {btns && btns.length > 0 ? (
          btns.map((btn, index) => (
            <Link 
              id={btn?.id || `btn_menu_${index}`}
              className="btn fs-5 px-2" 
              onClick={btn.onClick}  // Usando onClick para chamar a função
              to={btn.to}
              key={`dropdow_menu_component_${index}`}  // Adicionando a chave para evitar erro de lista
            >
              <i className={`bx ${btn.icon}`}></i>
            </Link>
          ))
        ) : null}
        
        {links && links.length > 0 ? (
          <>
            <Dropdown.Toggle
              variant="transparent"
              id="dropdown-basic"
              className="pe-0 ps-2 dropdown-toggle-no-arrow"
            >
              <i className="bi bi-three-dots-vertical"></i>
            </Dropdown.Toggle>
        
            <Dropdown.Menu>
              {links.map((link, index) => (
                <React.Fragment key={`link-fragment-${index}`}>
                  {link.divider && <Dropdown.Divider />}
                  {(link.name || link.icon) && (
                    <Dropdown.Item
                      as={Link}
                      onClick={link.onClick}
                      to={link.to}
                      eventKey={link.name}
                    >
                      <i className={`bi ${link.icon}`}></i> {link.name}
                    </Dropdown.Item>
                  )}
                </React.Fragment>
              ))}
            </Dropdown.Menu>
          </>
        ) : null}
      </Dropdown>
    </div>
  );
};

export default MenuComponente;